import { render, staticRenderFns } from "./Dog-copropietario-list.vue?vue&type=template&id=6e8b12ae&scoped=true&"
import script from "./Dog-copropietario-list.vue?vue&type=script&lang=js&"
export * from "./Dog-copropietario-list.vue?vue&type=script&lang=js&"
import style0 from "./Dog-copropietario-list.vue?vue&type=style&index=0&id=6e8b12ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b12ae",
  null
  
)

export default component.exports